import CustomLoader from 'react-loaders';

import './Loader.scss';

const Loader = () => (
  <CustomLoader
    type="ball-scale-ripple-multiple"
    innerClassName="loader-default"
    active
  />
);

export default Loader;
